export default {
  author: {
    name: '刘'
  },
  login: {
    title: 'Clover 博客系统',
    account: '账号',
    password: '密码',
    remember: '记住密码',
    login: '登录',
    register: '注册账号'
  },
  register: {
    title: '欢迎 注册',
    account: '账号',
    e_mail: '邮箱',
    password: '密码',
    again_pass: '再次输入',
    register: '注册'
  },
  error: {
    title: 'Oh no!!',
    line1: '你查找的页面去了火星',
    line2: '重新输入链接或返回',
    back: '返 回 上 一 级'
  },
  navbar: {
    title: '后台管理系统',
    screenfull: '全屏',
    profile: '个人中心',
    avatar: '修改头像',
    github: '项目仓库',
    logOut: '退出登录'
  },
  router: {
    dashboard: '仪表盘',
    homepage: '个人中心',
    account: '账号设置',
    guide: '导航',
    introduction: '简述',
    media: '媒体库',
    icon: '图标库',
    todo: '任务列表',
    external_link: '项目仓库',
    theme: '主题',
    essay: '文章',
    post_new: '写文章',
    all_essay: '所有文章',
    category: '分类目录',
    essay_detail: '文章详情',
    category_detail:'编辑分类目录'
  },
  dashboard: '仪表盘'
}



// WEBPACK FOOTER //
// ./src/lang/zh.js